import { articleMetaBySlug } from "./meta";

export const meta = articleMetaBySlug["sleep-and-running"]!;

export function Body() {
  return (
    <>
      <p>
        Most runners know that sleep matters, but few plan for it the way they plan their
        training. What happens when athletes sleep more, and what does too little sleep cost?
      </p>

      <h2>What the researchers did</h2>
      <p>
        In a study at Stanford University, 11 basketball players kept their normal sleep for two
        to four weeks. For the next five to seven weeks, they tried to spend at least ten hours
        in bed each night. The researchers measured their sleep, timed a sprint and recorded
        their shooting after every practice.
      </p>
      <p>
        A review from 2015 went through the research on sleep loss and exercise performance.
      </p>

      <h2>What they found</h2>
      <p>
        The players slept almost two hours more per night. Their sprint time improved from 16.2
        to 15.5 seconds, and their free-throw and three-point shooting both improved by about 9
        percent. They reported less fatigue and felt better during practice.
      </p>
      <p>
        The review found more mixed results for sleep loss. Some maximal efforts held up after a
        poor night, but the few studies of athletes found that sport-specific performance got
        worse. Thinking was slower and less accurate. Poor sleep over time
        could also give symptoms that resemble overtraining.
      </p>

      <h2>What it means for you</h2>
      <p>
        Sleep is part of your training. If you are building up to a race or have a hard block
        of training, more sleep is one of the simplest things you can add.
      </p>
      <p>
        One bad night before a race is common and rarely ruins the result. Several weeks of too
        little sleep are a different matter. Then it is better to make the training a bit easier
        than to push through.
      </p>

      <h2>What the studies can't tell you</h2>
      <p>
        The sleep extension study had 11 young male basketball players and no control group.
        Sprint and shooting are not the same as endurance running. The review describes the
        results as uncertain and calls for more research.
      </p>

      <h2>How we use it</h2>
      <p>
        PX7 Training asks how you feel before a session. If you have slept badly for several
        nights, say so, and the next session adjusts.
      </p>

      <h2>Sources</h2>
      <ul>
        <li>
          Mah et al. (2011), The effects of sleep extension on the athletic performance of
          collegiate basketball players.{" "}
          <a href="https://doi.org/10.5665/SLEEP.1132">Sleep</a>.
        </li>
        <li>
          Fullagar et al. (2015), Sleep and athletic performance: the effects of sleep loss on
          exercise performance, and physiological and cognitive responses to exercise.{" "}
          <a href="https://doi.org/10.1007/s40279-014-0260-0">Sports Medicine</a>.
        </li>
      </ul>
    </>
  );
}
